<div class="panel panel-info">
    @if (employee) {
        <div class="panel-heading px-4 py-3 justify-content-between">
            <div class="d-inline-flex">
                <h1>{{ employee.employeeName }}</h1>
                @if (mapsEnabled$ | async) {
                    <app-toggle-labelled
                        id="viewMode"
                        class="ml-auto"
                        label1="LIST_VIEW"
                        label2="MAP_VIEW"
                        (change)="toggleMap()"
                    ></app-toggle-labelled>
                }
                <div class="ml-4 my-auto">
                    <span class="employee-info-box mr-2 my-auto"
                        id="employee-transport">{{ (employee.transport).toUpperCase() | translate }}</span>
                    @if (employeeKeyNumbers && employeeKeyNumbers.rideSharing) {
                        <span class="employee-info-box"
                              id="employee-ride-sharing">{{ 'RIDE_SHARING' | translate }}</span>
                    }
                </div>
            </div>
            <div class="d-inline-flex">
                @if (showCancelDropZoneFeature | async) {
                    <div [ngClass]="{'invisible': !isDragging}"
                         class="drop-box d-flex mr-3" cdkDropList (cdkDropListDropped)="cancelDragging()">
                        <div class="drop-empty-row">
                            <span class="my-auto ml-1 mr-2">{{ 'CANCEL_DRAG_DROPZONE' | translate }}</span>
                        </div>
                    </div>
                }
                @if (minimizeViewFeatureEnabled | async) {
                    @if (isViewMinimized) {
                        <button
                            (click)="openExportModal()"
                            type="button" class="btn btn-default print-btn mr-3 my-auto">
                            {{ "PRINT" | translate }}
                        </button>
                    }
                    <button class="btn btn-default alter-view-btn my-auto" (click)="updateViewStatus()">
                        @if (isViewMinimized) {
                            {{ "EXPAND_STATISTICS" | translate }}
                        } @else {
                            {{ "COLLAPSE_STATISTICS" | translate }}
                        }
                    </button>
                }
            </div>
        </div>
        <div class="panel-body px-4 pb-4">
            <div class="container-flex">
                @if (!mapVisible) {
                    @if (employeeKeyNumbers && !isViewMinimized) {
                        <div class="route-key-container d-inline-flex justify-content-between">
                            <app-route-key-number
                                translation="LATE_ARRIVALS"
                                tooltip="LATE_ARRIVALS_OBJECTIVE_INFO"
                                [printView]="false"
                                [compareValue]="employeeKeyNumbers.totalTimeBreakingTimeWindowsInSeconds"
                            >
                                <ng-container content>
                                    <div class="d-inline-flex">
                                        <span class="key-number-content">
                                            {{ routeKeyNumberWeights.accurateArrivals[0] }}
                                        </span>
                                        <div>
                                            {{ "HOURS_SHORT" | translate }}&nbsp;
                                        </div>
                                    </div>
                                    <div class="d-inline-flex">
                                        <span class="key-number-content">
                                            {{ routeKeyNumberWeights.accurateArrivals[1] }}
                                        </span>
                                        <div>
                                            {{ "MINUTES_SHORT" | translate }}
                                        </div>
                                    </div>
                                </ng-container>
                            </app-route-key-number>
                            <app-route-key-number
                                translation="TRAVEL_TIME"
                                tooltip="{{travelTimeTransportService.formatTransportTooltip(transportTravelTime)}}"
                                [printView]="false"
                                [compareValue]="employeeKeyNumbers.totalTravelTimeSeconds"
                            >
                                <ng-container content>
                                    <div class="d-inline-flex">
                                        <span class="key-number-content">
                                            {{ routeKeyNumberWeights.travelTime[0] }}
                                        </span>
                                        <div>
                                            {{ "HOURS_SHORT" | translate }}&nbsp;
                                        </div>
                                    </div>
                                    <div class="d-inline-flex">
                                        <span class="key-number-content">
                                            {{ routeKeyNumberWeights.travelTime[1] }}
                                        </span>
                                        <div>
                                            {{ "MINUTES_SHORT" | translate }}
                                        </div>
                                    </div>
                                </ng-container>
                            </app-route-key-number>
                            <app-route-key-number
                                translation="VISIT_CONTINUITY"
                                tooltip="VISIT_CONTINUITY_OBJECTIVE_INFO"
                                [textParam]="routeKeyNumberWeights.visitContinuity"
                                [printView]="false"
                                [compareValue]="employeeKeyNumbers.totalNumberOfPatientsVisitedByEmployeesNotInPrimaryGroup"
                            >
                                <ng-container content>
                                    <div><span
                                        class="key-number-content">{{ routeKeyNumberWeights.visitContinuity }}</span>
                                        {{ "X_NEW_VISITS" | translate }}&nbsp;
                                    </div>
                                </ng-container>
                            </app-route-key-number>
                            @if (routeKeyNumberWeights.overMaxEmployeeCount) {
                                <app-route-key-number
                                    [printView]="false"
                                    translation="ABOVE_MAX"
                                    tooltip="ABOVE_MAX_VISIT_CONTINUITY_OBJECTIVE_INFO"
                                    [compareValue]="employeeKeyNumbers.numberOfPatientsVisitedByOverMaxEmployees"
                                >
                                    <ng-container content>
                                        <div><span
                                            class="key-number-content">{{ routeKeyNumberWeights.overMaxEmployeeCount }}</span>
                                            &nbsp;{{ "VISITS" | translate }}
                                        </div>
                                    </ng-container>
                                </app-route-key-number>
                            }
                            <app-route-key-number
                                translation="OVERQUALIFICATION"
                                tooltip="OVERQUALIFICATION_OBJECTIVE_INFO"
                                [printView]="false"
                                [compareValue]="employeeKeyNumbers.numberOfTasksWithOverqualifiedWork"
                            >
                                <ng-container content>
                                    <div><span
                                        class="key-number-content">{{ routeKeyNumberWeights.correctCompetence }}</span>
                                        {{ "VISITS" | translate }}
                                    </div>
                                </ng-container>
                            </app-route-key-number>
                            <app-route-key-number
                                translation="TASK_TIME"
                                tooltip="TASK_TIME_OBJECTIVE_INFO"
                                [printView]="false"
                                [compareValue]="employeeKeyNumbers.totalTimeForOfficeTasks + employeeKeyNumbers.totalPatientTime"
                            >
                                <ng-container content>
                                    <div class="d-inline-flex">
                                        <span class="key-number-content">
                                            {{ routeKeyNumberWeights.taskTime[0] }}
                                        </span>
                                        <div>
                                            {{ "HOURS_SHORT" | translate }}&nbsp;
                                        </div>
                                    </div>
                                    <div class="d-inline-flex">
                                        <span class="key-number-content">
                                            {{ routeKeyNumberWeights.taskTime[1] }}
                                        </span>
                                        <div>
                                            {{ "MINUTES_SHORT" | translate }}
                                        </div>
                                    </div>
                                </ng-container>
                            </app-route-key-number>
                            @if (rosterInInstance) {
                                <app-route-key-number
                                    [printView]="false"
                                    translation="DIFFERENT_ROSTER_DEPARTMENT"
                                    tooltip="DIFFERENT_ROSTER_DEPARTMENT_OBJECTIVE_INFO"
                                    [compareValue]="employeeKeyNumbers.numberOfTasksWithDifferentRosterDepartment"
                                >
                                    <ng-container content>
                                        <div><span
                                            class="key-number-content">{{ routeKeyNumberWeights.differentRosterTasks }}</span>
                                            {{ "PROGRESS_DIFFERENT_DEPARTMENT" | translate }}
                                        </div>
                                    </ng-container>
                                </app-route-key-number>
                            }
                        </div>
                    }
                    <app-route-planning-tasks
                        [employee]="employee"
                        [visits]="employeeTasks"
                        [employeeKeyNumbers]="employeeKeyNumbers"
                        [saving]="saving"
                        [pdfView]="false"
                        [dragDisabled]="dragDisabled"
                        (reloadRoutes)="loadRoutesInfo($event)"
                        [routeSolution]="routes.tasks"
                    ></app-route-planning-tasks>
                }
                @if (mapVisible) {
                    <app-map
                        customClass="map-container"
                        [centerLocation]="officeLocation$ | async"
                        [wayPoints]="taskLocations"
                        [transport]="employee.transport"
                    ></app-map>
                }
            </div>
        </div>
    }
    @if (!employee) {
        <span class="spinner spinner-lg absolute-centering"></span>
    }
</div>
